/** 表示用のフォーマット。マイナスは U+2212 を使い、数字と同じ高さに揃える */

/** 精算ポイント。+55 / −62 / 0 */
export function formatPoint(n: number): string {
  if (n > 0) return `+${n}`;
  if (n < 0) return `−${Math.abs(n)}`;
  return '0';
}

/** 素点。45,000 / −2,000 */
export function formatScore(n: number): string {
  const s = Math.abs(n).toLocaleString('ja-JP');
  return n < 0 ? `−${s}` : s;
}

/** 平均順位など。2.14 */
export function formatAverage(n: number, digits = 2): string {
  return n.toFixed(digits);
}

/** 8/31 21:40 */
export function formatDateTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getMonth() + 1}/${d.getDate()} ${String(d.getHours()).padStart(2, '0')}:${String(
    d.getMinutes(),
  ).padStart(2, '0')}`;
}

/** 8/31 */
export function formatDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getMonth() + 1}/${d.getDate()}`;
}

/** 8月31日 21:40 — 対局詳細の見出し用 */
export function formatLongDateTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getMonth() + 1}月${d.getDate()}日 ${String(d.getHours()).padStart(2, '0')}:${String(
    d.getMinutes(),
  ).padStart(2, '0')}`;
}

/** 名前の頭1文字。メンバー一覧のアバターに使う */
export function initial(name: string): string {
  return [...name][0] ?? '?';
}

/** datetime-local 入力に渡せる形式（ローカル時刻） */
export function toDateTimeLocalValue(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(
    d.getMinutes(),
  )}`;
}
